import { TooltipContent } from "@faire/deprecated-retailer-visitor-shared/features/PointOfSale/components/PDPInventory/TooltipContent";
import { Tooltip } from "@faire/deprecated-retailer-visitor-shared/features/PointOfSale/components/Tooltip";
import { usePOSSummary } from "@faire/deprecated-retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const OpenSizingInventoryHeader: React.FC<{
  isEmpty: boolean;
}> = ({ isEmpty }) => {
  const { name: posCompanyName } = usePOSSummary();
  if (isEmpty) {
    return <Spacer size="1x" />;
  }

  return (
    <Column align="flex-start">
      <Tooltip
        target={
          <Typography textDecoration="dottedUnderline" align="left">
            <StrictLocalMsg
              id="Uy63G3"
              defaultMessage="In {posCompanyName}"
              description={{
                text: "Table header indicating a column with product inventory, refer to image",
                img: "https://cdn.faire.com/fastly/cac7a1a5149949c5505279e1084ad7308f3fa6a84a03538299442c657ef15c65.png",
              }}
              values={{ posCompanyName }}
            />
          </Typography>
        }
      >
        <TooltipContent />
      </Tooltip>
    </Column>
  );
};
